import { I18nProps } from '../type'
import { historyEn } from './history'
import { valuedEn } from './valued'
import { teamMemberEn } from './team-member'
import { servicesEn, type ServiceProps } from './services'
import { modelsEn } from './model'

export interface AboutUsProps {
  history: any
  valued: any
  teamMember: any
  services: ServiceProps
  models: any
}

const aboutUsEn: AboutUsProps = {
  history: historyEn,
  services: servicesEn,
  teamMember: teamMemberEn,
  valued: valuedEn,
  models: modelsEn,
}

export const i18nAboutUs: I18nProps<AboutUsProps> = {
  en: aboutUsEn,
  es: aboutUsEn,
  cn: aboutUsEn,
}
